module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/loading-spinner/loading-spinner.component.sass
// module id = ./src/app/shared/loading-spinner/loading-spinner.component.sass
// module chunks = main